"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var OrderTotalContentState_1 = require("./OrderTotalContentState");
var thisStyles = require("./OrderTotalContent.scss");
var styles = require("../../CartConfigurationContainer/CartConfiguration.scss");
var ui_components_1 = require("@idp/ui-components");
var LabelProps_1 = require("@idp/ui-components/components/atoms/Label/LabelProps");
var utils_1 = require("@idp/ui-components/utils");
var Utils = require("../../../utils/UtilityFunctions");
var OrderTotalContent = /** @class */ (function (_super) {
    __extends(OrderTotalContent, _super);
    function OrderTotalContent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new OrderTotalContentState_1.default();
        return _this;
    }
    OrderTotalContent.prototype.render = function () {
        var isMobile = Utils.isMobile();
        return (React.createElement("div", { className: styles.pt20 },
            React.createElement(React.Fragment, null,
                React.createElement(ui_components_1.Label, { data: { text: this.props.data.heading }, options: {
                        className: (this.props.options && this.props.options.noBoldStyle) ?
                            styles.pb10 : thisStyles.marginBottom16,
                        size: (this.props.options && this.props.options.noBoldStyle) ?
                            LabelProps_1.LabelSizes.MEDIUM : isMobile ? LabelProps_1.LabelSizes.SMALLHEADING18 :
                            LabelProps_1.LabelSizes.SMALLHEADING24,
                    } }),
                (this.props.options && this.props.options.seperatorAfterHeading) &&
                    React.createElement("div", { className: [styles.secBottomBorder, styles.mb10].join(' ') }),
                React.createElement("div", { className: thisStyles.marginBottom20 },
                    React.createElement("div", { className: thisStyles.duePrices },
                        React.createElement(ui_components_1.Label, { testId: utils_1.default('OrderTotalContent', 'Label', 'DeviceCost'), data: { text: this.props.data.deviceCostLabel }, options: {
                                className: thisStyles.cardLineUpdateOption,
                                size: (this.props.options && this.props.options.noBoldStyle) ?
                                    LabelProps_1.LabelSizes.MEDIUM : LabelProps_1.LabelSizes.SMALLHEADING18
                            } }),
                        React.createElement(ui_components_1.Label, { testId: utils_1.default('OrderTotalContent', 'Label', 'Cost'), data: { text: "$" + this.props.data.deviceCost }, options: {
                                className: [thisStyles.rightAlign, thisStyles.cardLineUpdateOption].join(' '),
                                size: (this.props.options && this.props.options.noBoldStyle) ?
                                    LabelProps_1.LabelSizes.MEDIUM : LabelProps_1.LabelSizes.SMALLHEADING18,
                            } })),
                    React.createElement("div", { className: thisStyles.duePrices },
                        React.createElement(ui_components_1.Label, { testId: utils_1.default('OrderTotalContent', 'Label', 'MonthlyPlan'), data: { text: this.props.data.monthlyCostLabel }, options: {
                                className: thisStyles.cardLineUpdateOption,
                                size: (this.props.options && this.props.options.noBoldStyle) ?
                                    LabelProps_1.LabelSizes.MEDIUM : LabelProps_1.LabelSizes.SMALLHEADING18
                            } }),
                        React.createElement(ui_components_1.Label, { testId: utils_1.default('OrderTotalContent', 'Label', 'MonthlyPlanCost'), data: { text: "$" + this.props.data.monthlyPlanCost + '/mo.' }, options: {
                                className: [thisStyles.rightAlign, thisStyles.cardLineUpdateOption].join(' '),
                                size: (this.props.options && this.props.options.noBoldStyle) ?
                                    LabelProps_1.LabelSizes.MEDIUM : LabelProps_1.LabelSizes.SMALLHEADING18,
                            } }))),
                this.props.data.headsUpLabel &&
                    React.createElement(ui_components_1.Label, { data: { text: this.props.data.headsUpLabel }, options: { className: thisStyles.marginBottom20,
                            size: isMobile ? LabelProps_1.LabelSizes.SMALLBODY : LabelProps_1.LabelSizes.MEDIUMBODY,
                        } }))));
    };
    return OrderTotalContent;
}(React.Component));
exports.default = OrderTotalContent;
//# sourceMappingURL=OrderTotalContent.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/OrderTotalContent/OrderTotalContent.js
// module id = 2374
// module chunks = 8